import {Injectable} from '@angular/core';
import {AppConstants} from '../shared/app.constants';
import {AuthService} from '../auth.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class PotentialService {

  constructor(private appConstants: AppConstants, private auth: AuthService, private http: HttpClient) {
  }

  getAllPotentials(): Observable<any> {
    const url = environment.apiBase + 'potentials';
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(response => response).catch(this.appConstants.errorHandler);
  }

  approvePotential(potentialId): Observable<any> {
    const url = environment.apiBase + `user/${potentialId}/potentials`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.put(url, {}, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

  rejectPotential(potentialId): Observable<any> {
    const url = environment.apiBase + `potentials/${potentialId}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.delete(url, {headers}).map(response => response).catch(this.appConstants.errorHandler);
  }

  getPotential(potentialId): Observable<any> {
    const url = environment.apiBase + `potential/${potentialId}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(response => response).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/potentials/potential.service.ts